export const getTranslations = (t, outOfStockTitle = "") => {
  return {
    search: t("kf.pdp.label.searchBtn"),
    quickView: t("kf.button.quickView"),
    outOfStockLabel: outOfStockTitle || t("kf.curated.label.outOfStock"),
    backOrderMssg: days => t("kf.cart.label.backOrderMssg", { days }),
  }
}
